module.exports = __webpack_public_path__ + "static/media/README.90acfc44.md";